import { useState } from "react";
import { register, type RegisterResponse } from "../api/auth";
import Setup2FAPage from "./Setup2FAPage";

export default function BootstrapPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reg, setReg] = useState<RegisterResponse | null>(null);

  if (reg) {
    return (
      <Setup2FAPage
        userId={reg.userId}
        provisioningUri={reg.totpProvisioningUri}
        secret={reg.totpSecret}
      />
    );
  }

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await register(email, password);
      setReg(r);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <h1>Create the first admin</h1>
        <p>No accounts exist yet. Create the first admin account below.</p>
        <form onSubmit={submit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              autoComplete="email"
            />
          </label>
          <label>
            Password (min. 8 characters)
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </label>
          {error && <p className="auth-error">{error}</p>}
          <button type="submit" disabled={busy || !email || password.length < 8}>
            {busy ? "Creating…" : "Create admin account"}
          </button>
        </form>
      </div>
    </div>
  );
}
